// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Matrix$ReactTemplate = require("./Matrix.bs.js");
var Game_model$ReactTemplate = require("./Game_model.bs.js");
var Js_array_plus$ReactTemplate = require("./Js_array_plus.bs.js");

function figure_size(figure) {
  var maxX = figure.reduce((function (max, param) {
          var x = param[0];
          if (max > x) {
            return max;
          } else {
            return x;
          }
        }), 0);
  var maxY = figure.reduce((function (max, param) {
          var y = param[1];
          if (max > y) {
            return max;
          } else {
            return y;
          }
        }), 0);
  return /* tuple */[
          maxX + 1 | 0,
          maxY + 1 | 0
        ];
}

function figure_to_matrix(figure) {
  var match = figure_size(figure);
  return Js_array_plus$ReactTemplate.init_matrix(match[0], match[1], (function (point) {
                if (figure.some((function (figure_point) {
                          return Caml_obj.caml_equal(figure_point, point);
                        }))) {
                  return /* Alive */1;
                } else {
                  return /* Dead */0;
                }
              }));
}

function evolve(figure) {
  return Js_array_plus$ReactTemplate.trim_matrix((function (s) {
                return s === /* Dead */0;
              }), Game_model$ReactTemplate.next_generation(Js_array_plus$ReactTemplate.pad_matrix(/* Dead */0, 1, figure)));
}

function figure_states(figure) {
  var _states = [figure];
  var _tries = 5;
  while(true) {
    var tries = _tries;
    var states = _states;
    var next = evolve(states[0]);
    var exists = states.some((function(next){
        return function (s) {
          return Caml_obj.caml_equal(s, next);
        }
        }(next)));
    var new_states = exists ? states : [next].concat(states);
    if (tries <= 0 || exists) {
      return new_states;
    } else {
      _tries = tries - 1 | 0;
      _states = new_states;
      continue ;
    }
  };
}

function Figure(Props) {
  var coords = Props.coords;
  var aliveColorOpt = Props.aliveColor;
  var deadColorOpt = Props.deadColor;
  var aliveColor = aliveColorOpt !== undefined ? aliveColorOpt : "#0029f5";
  var deadColor = deadColorOpt !== undefined ? deadColorOpt : "#bdbdbd";
  var all_states = figure_states(figure_to_matrix(coords));
  var match = React.useState((function () {
          return 0;
        }));
  var setCurrent = match[1];
  React.useEffect((function () {
          var id = setInterval((function (param) {
                  return Curry._1(setCurrent, (function (n) {
                                if ((n + 1 | 0) === all_states.length) {
                                  return 0;
                                } else {
                                  return n + 1 | 0;
                                }
                              }));
                }), 1000);
          return (function (param) {
                    clearInterval(id);
                    return /* () */0;
                  });
        }));
  return React.createElement(Matrix$ReactTemplate.make, {
              value: all_states[match[0]],
              cellSize: "14px",
              style: (function (param, state) {
                  return {
                          background: state ? aliveColor : deadColor
                        };
                })
            });
}

var make = Figure;

exports.figure_size = figure_size;
exports.figure_to_matrix = figure_to_matrix;
exports.evolve = evolve;
exports.figure_states = figure_states;
exports.make = make;
/* react Not a pure module */
